module.exports = __webpack_public_path__ + "img/intro.14532cfe.png";